import { render, staticRenderFns } from "./ReminderBar.vue?vue&type=template&id=1282259b&"
import script from "./ReminderBar.vue?vue&type=script&lang=ts&"
export * from "./ReminderBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports